import { put } from "../../../../utils/api";
import GenericViewDrawer1 from "../../GenericViewDrawer1";

const ViewDetailsDrawerLowCarbonProduct = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Period",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Product Name",
      previous: data?.productName,
      requested: data?.editValue?.productName,
    },
    {
      label: "Conventional Product",
      previous: data?.conventionalProductName,
      requested: data?.editValue?.conventionalProductName,
    },
    {
      label: "Quantity Sold",
      previous: data?.quantitySold,
      requested: data?.editValue?.quantitySold,
    },
    {
      label: "Unit",
      previous: data?.unit,
      requested: data?.editValue?.unit,
    },
    {
      label: "Conventional Product Emission Factor",
      previous: data?.emissionFactorConventionalProduct,
      requested: data?.editValue?.emissionFactorConventionalProduct,
    },
    {
      label: "Product Sold Emission Factor",
      previous: data?.emissionFactorProductSold,
      requested: data?.editValue?.emissionFactorProductSold,
    },
    // {
    //   label: "Total Emission",
    //   previous: data?.totalEmission,
    //   requested: data?.editValue?.totalEmission || "—",
    // },
    {
      label: "Remarks",
      previous: data?.remarks,
      requested: data?.editValue?.remarks,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Low Carbon Product Use Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerLowCarbonProduct;
